module.exports = __webpack_public_path__ + "img/contraste2.b6f73fb5.png";